











import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class CampoComTitulo extends Vue {
	@Prop({ type: String, required: true }) titulo!: string
	@Prop({ type: String, required: true }) valor!: string
	@Prop({ type: String, default: null }) corDoValor!: string | null
}
